'use strict';

var linchpin = require('./hampers'),
	lpin = require('./secureacceptance');

var dialog = {
		saveHamper: function (params) {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				if (params.options.dialogClass === 'save-hamper-dialog') {
				linchpin.saveHamperEvent(params);
				}
			}
		},

		addNewCard: function () {
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				var contactPreferences = '';
				if ($('input[name="contactPreferences"]').length > 0) {
					contactPreferences = $('input[name="contactPreferences"]').val();
				}
				lpin.addNewCardEvent(contactPreferences);
			}
		}
};

module.exports = dialog;
